// Mobx
import { computed, observable } from "mobx";
// Store
import { Store } from "#/store";
// Api
import { Api } from "#/api";

// Models
import { FahrzeugModell } from "#/common/models/model_selection/FahrzeugModell";

interface FahrzeugModelData {
  index: number;
  sparte: number;
  gueltigkeit: string;
  fahrzeugModelle: FahrzeugModell[];
}

export class ViewModel {
  @observable
  public fahrzeugModelData: FahrzeugModelData[] = [];

  public constructor() {}

  @computed
  public get sichtbareFahrzeugModelle() {
    const store = Store.instance;

    if (!store.selectionFilter.selectedFilter) return this.fahrzeugModelData;

    return this.fahrzeugModelData.slice().filter((fahrzeug, index) => {
      let selectedFilter = store.selectionFilter.selectedFilter;
      return (
        selectedFilter &&
        fahrzeug.sparte == selectedFilter.sparte &&
        selectedFilter.gueltigkeiten.includes(fahrzeug.gueltigkeit)
      );
    });
  }

  @computed
  public get totalCount() {
    return this.sichtbareFahrzeugModelle.flatMap((x) =>
      x.fahrzeugModelle.slice()
    ).length;
  }

  public async loadModuleData(instance: any): Promise<boolean> {
    const store = Store.instance;

    for (let configIndex in instance.config.slice()) {
      for (let gultingIndex in instance.config[
        configIndex
      ].flkGueltigkeiten.slice()) {
        try {
          const response = await Api.katalogService.getModelSelection(
            instance.config[configIndex].sparte,
            instance.config[configIndex].flkGueltigkeiten[gultingIndex]
              .flkGueltig
          );

          this.fahrzeugModelData.push({
            index:
              gultingIndex == "0" ? instance.config[configIndex] : undefined,
            sparte: instance.config[configIndex].sparte,
            gueltigkeit:
              instance.config[configIndex].flkGueltigkeiten[gultingIndex]
                .flkGueltig,
            fahrzeugModelle: response,
          });
        } catch (err) {
          console.log(err);
        }
      }
    }

    return true;
  }

  public resetModuleData() {
    const store = Store.instance;
  }
}
